import type { CardDefinition } from "../domain/types/index.js";
import { REWARD_POOLS } from "../content/rewardPools.js";

export function isCurseCard(definition: CardDefinition): boolean {
  return definition.type === "task" || definition.type === "worker" && definition.progress === 0 && !definition.heal;
}

export function cardFrameClass(definition: CardDefinition): "is-curse" | "is-worker" | "is-action" {
  if (isCurseCard(definition)) return "is-curse";
  return definition.type === "worker" ? "is-worker" : "is-action";
}

/**
 * 報酬プールをまたぐカードは、出現しうる最大規模の装飾を使う。
 * 大規模は虹枠、中規模はホログラム枠。小規模のみのカードは種別枠のまま。
 */
export function cardRewardFrameClass(definition: CardDefinition): "is-hologram-frame" | "is-rainbow-frame" | "" {
  const isInPool = (size: "small" | "medium" | "large") =>
    (REWARD_POOLS[size].workers as readonly string[]).includes(definition.id)
    || (REWARD_POOLS[size].actions as readonly string[]).includes(definition.id);

  if (isInPool("large")) return "is-rainbow-frame";
  if (isInPool("medium")) return "is-hologram-frame";
  return "";
}

export function cardKindLabel(definition: CardDefinition): string {
  if (definition.type === "task") return "対応事項";
  return definition.type === "worker" ? "労働力" : "施策";
}
